import { useMutation, useQuery } from '@tanstack/react-query';
import { verifyDonation, getDonation } from '@/lib/api/donations';

/**
 * Hook to verify a donation payment
 * Calls the verify endpoint and handles the response
 */
export function usePaymentVerification(_donationId: string | null) {
  return useMutation({
    mutationFn: (id: string) => verifyDonation(id),
    onError: (error) => {
      console.error('Payment verification failed:', error);
    },
  });
}

/**
 * Hook to poll donation status
 * Useful when payment verification is asynchronous
 */
export function useDonationStatus(donationId: string | null, enabled: boolean = true) {
  return useQuery({
    queryKey: ['donation-status', donationId],
    queryFn: () => {
      if (!donationId) {
        throw new Error('Donation ID is required');
      }
      return getDonation(donationId);
    },
    enabled: !!donationId && enabled,
    refetchInterval: (query) => {
      const data = query.state.data;
      // Stop polling if donation is succeeded or failed
      if (data?.data.status === 'succeeded' || data?.data.status === 'failed') {
        return false;
      }
      // Poll every 2 seconds for pending/processing status
      return 2000;
    },
    retry: 3,
  });
}
